import '../admin-shared.css'

import { PageHeader } from '../../../Components'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import {
  setAllErrorOutOfOffice,
  setAllErrorsTAProfile,
  setAllErrorsWithKeyLabel
} from './panelOperationsFunctions'

const language = cap.language.state || 'IT'
const t = translations[language]

const OPERATIONS = [
  {
    title: t.admAggiornaLabelErrori,
    hint: t.admAggiornaLabelErroriHint,
    icon: 'pi-pencil',
    onClick: setAllErrorsWithKeyLabel
  },
  {
    title: t.admAggiornaErroriTAProfile,
    hint: t.admAggiornaErroriTAProfileHint,
    icon: 'pi-user',
    onClick: setAllErrorsTAProfile
  },
  {
    title: t.admAggiornaErroriOutOfOffice,
    hint: t.admAggiornaErroriOutOfOfficeHint,
    icon: 'pi-envelope',
    onClick: setAllErrorOutOfOffice
  }
]

export const PanelOperationsAdmin = () => {
  return (
    <div className="admin-page--narrow">
      <PageHeader title={t.mxTitoloPanelOperations} subtitle={t.admSottotitoloPanel} />

      <div className="ncard">
        <div className="ncard__head">
          <div className="ncard__ico">
            <i className="pi pi-exclamation-triangle" style={{ fontSize: 16 }} />
          </div>
          <div>
            <h3 className="ncard__title">{t.admOperazioniManutenzione}</h3>
            <div className="ncard__sub">{t.admSottotitoloManutenzione}</div>
          </div>
        </div>
        <div className="ncard__body admin-panel-operations__list">
          {OPERATIONS.map((op) => (
            <div key={op.title} className="admin-panel-operations__item">
              <div className="admin-panel-operations__icon">
                <i className={`pi ${op.icon}`} style={{ fontSize: 20 }} />
              </div>
              <div className="admin-panel-operations__content">
                <div className="admin-panel-operations__title">{op.title}</div>
                <div className="admin-panel-operations__hint">{op.hint}</div>
              </div>
              <button type="button" className="nbtn nbtn--primary nbtn--sm" onClick={op.onClick}>
                <i className="pi pi-play" style={{ fontSize: 12 }} />
                {t.admEsegui}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
